import { reduxDB } from './index';

export const updateGuideSearchQuery = state => reduxDB.guideSearchQuery.update(state);

export const updateGuideSearchFilter = state => reduxDB.guideSearchFilters.update(state);

export const updateGuideSortKeys = state => reduxDB.guideSortKeys.update(state);
